// React page to handle unsubscribe links and show a confirmation message

import React, { useEffect, useState } from 'react';

// If you already have a central config for the API URL, import it instead
const HOMILIES_API_URL = process.env.REACT_APP_HOMILIES_API_URL || 'https://tx02qpcowl.execute-api.us-east-1.amazonaws.com';

function getQueryParam(name) {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

const HomilyEmailUnsubscribe = () => {
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    const emailParam = getQueryParam('email');
    const sigParam = getQueryParam('sig');

    if (!emailParam || !sigParam) {
      setStatus('error');
      setMessage('This unsubscribe link is invalid. Please log in to manage your notification settings.');
      return;
    }

    setEmail(emailParam);

    const run = async () => {
      try {
        setStatus('loading');

        const url = `${HOMILIES_API_URL}/homily-email-unsubscribe?email=${encodeURIComponent(
          emailParam,
        )}&sig=${encodeURIComponent(sigParam)}`;

        const response = await fetch(url, {
          method: 'GET',
        });

        const data = await response.json();

        if (!response.ok || !data.success) {
          setStatus('error');
          setMessage(
            data.message ||
              'We were unable to process your unsubscribe request. Please log in to your Skroop account to manage your settings.',
          );
          return;
        }

        setStatus('success');
        setMessage(
          data.message ||
            'You have been unsubscribed from Daily Homily emails. If you would like to receive them again, please log in to your Skroop account and re-enable email notifications.',
        );
      } catch (error) {
        console.error('Error calling unsubscribe API:', error);
        setStatus('error');
        setMessage(
          'An error occurred while processing your request. Please try again later or log in to your Skroop account to manage your settings.',
        );
      }
    };

    run();
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        padding: '24px',
      }}
    >
      <div
        style={{
          maxWidth: '480px',
          width: '100%',
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          padding: '24px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
          fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        }}
      >
        <h1 style={{ fontSize: '1.5rem', marginBottom: '16px' }}>Daily Homily Email Preferences</h1>

        {status === 'loading' && (
          <p style={{ margin: 0 }}>Updating your email preferences…</p>
        )}

        {status === 'success' && (
          <>
            <p style={{ marginBottom: '12px' }}>{message}</p>
            {email && (
              <p style={{ fontSize: '0.9rem', color: '#555' }}>
                Email: <strong>{email}</strong>
              </p>
            )}
            <p style={{ fontSize: '0.9rem', color: '#555' }}>
              To change this in the future, please log in at{' '}
              <a href="https://skroop.org" target="_blank" rel="noreferrer">
                skroop.org
              </a>{' '}
              and adjust your notification settings.
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <p style={{ marginBottom: '12px', color: '#b00020' }}>{message}</p>
            <p style={{ fontSize: '0.9rem', color: '#555' }}>
              You can always log in at{' '}
              <a href="https://skroop.org" target="_blank" rel="noreferrer">
                skroop.org
              </a>{' '}
              to manage your notification preferences.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default HomilyEmailUnsubscribe;